import React, { useEffect, useRef } from 'react';
import { Field, useForm } from '@framework/ui/Organisms/FinalForm';
import { IRequestServiceData } from './IRequestServiceData';
import EmailInput from '@/creditflowresearch/ui/common/components/EmailInput';
import Input from '@creditflowresearch/uilib/Input';
import InputLabel from '@creditflowresearch/uilib/Input/Label';
import PhoneInput from '@creditflowresearch/uilib/Input/PhoneInput';
import Textarea from '@creditflowresearch/uilib/Textarea';
import { CheckboxInput } from '@creditflowresearch/uilib/Checkbox';
import ReCaptcha from '@framework/ui/Molecules/Form/ReCaptcha';
import ReCaptchaPolicy from '@framework/ui/Molecules/Form/ReCaptcha/ReCaptchaPolicy';
import Button from '@creditflowresearch/uilib/Button';
import { useRequestServiceModalContext } from '@/creditflowresearch/application/RequestServiceModalContext';

import recaptchaStyles from '@framework/ui/Molecules/Form/ReCaptcha/recaptcha.module.scss';
import styles from './styles.module.scss';

const RequestServiceFields = () => {
  const form = useForm<IRequestServiceData, Partial<IRequestServiceData>>();
  const { invalid } = form.getState();
  const {
    setRecaptchaObject,
    isFetching,
    titleForm,
    isCaptcha,
    isSolutionsSelect,
    commentPlaceholder = 'Please provide additional details if applicable...',
  } = useRequestServiceModalContext();
  const recaptchaRef = useRef<ReCaptcha>(null);

  useEffect(() => {
    if (isCaptcha && recaptchaRef.current) {
      setRecaptchaObject(recaptchaRef.current.recaptchaRef.current);
    }
  }, [recaptchaRef]);

  return (
    <div className={ styles.modalContainer }>
      <div className={ styles.modalHeader }>
        <h1>{ titleForm }</h1>
      </div>
      <div className={ styles.modalBody }>
        <div className={ styles.modalRow }>
          <Field
            component={ Input }
            name="firstName"
            label="First Name"
            placeholder="First Name"
            dataTest="requestServiceModalFirstName"
            formFieldClassName={ styles.modalField }
          />
          <Field
            component={ Input }
            name="lastName"
            label="Last Name"
            placeholder="Last Name"
            dataTest="requestServiceModalLastName"
            formFieldClassName={ styles.modalField }
          />
        </div>
        <div className={ styles.modalRow }>
          <Field
            component={ Input }
            name="companyName"
            label="Company Name"
            placeholder="Company Name"
            dataTest="requestServiceModalCompanyName"
            formFieldClassName={ styles.fullWidthModalField }
          />
        </div>
        <div className={ styles.modalRow }>
          <Field
            name="email"
            type="email"
            placeholder="Corporate Email"
            label="Corporate Email"
            component={ EmailInput }
            dataTest="requestServiceModalEmail"
            formFieldClassName={ styles.modalField }
          />
          <Field
            component={ PhoneInput }
            name="phone"
            label="Phone"
            isFinalForm
            dataTest="requestServiceModalPhone"
            formFieldClassName={ styles.modalField }
          />
        </div>
        { isSolutionsSelect && (
          <div className={ styles.modalRow }>
            <div className={ styles.solutionsGroup }>
              <InputLabel>Which solution you are interested in?</InputLabel>
              <div className={ styles.solutionsRow }>
                <Field
                  type="checkbox"
                  name="creditFlowApi"
                  label="CreditFlow API"
                  component={ CheckboxInput }
                  isErrorMessage={ false }
                  dataTest="requestServiceModalSolutionCreditFlowApi"
                />
                <Field
                  type="checkbox"
                  name="officeAddInExcel"
                  label="Office Add-in for Excel"
                  component={ CheckboxInput }
                  isErrorMessage={ false }
                  dataTest="requestServiceModalSolutionOfficeAddInExcel"
                />
              </div>
            </div>
          </div>
        ) }
        <div className={ styles.modalRow }>
          <Field
            name="comment"
            placeholder={ commentPlaceholder }
            label="Comment"
            component={ Textarea }
            dataTest="requestServiceModalComment"
            formFieldClassName={ styles.fullWidthModalField }
            textareaClassName={ styles.modalFieldComment }
          />
        </div>
      </div>

      <div className={ styles.modalFooter }>
        {
          isCaptcha && (
            <Field
              name="recaptcha"
              component={ ReCaptcha }
              dataTest="requestServiceModalRecaptcha"
              visible={ false }
              className={ recaptchaStyles.recaptchaHidden }
              formFieldClassName={ styles.modalRecaptchaField }
              ref={ recaptchaRef }
            />
          )
        }
        <Button
          type="submit"
          variant="solid"
          color="primary"
          dataTest="requestServiceModalSubmitButton"
          className={ styles.modalSubmitButton }
          disabled={ invalid || isFetching }
        >
          Submit Request
        </Button>
        { isCaptcha && <ReCaptchaPolicy /> }
      </div>
    </div>
  );
};

export default RequestServiceFields;
